import { FC } from 'react';
import {
  Icon,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Text,
} from '@chakra-ui/react';
import { BiInfoCircle } from 'react-icons/bi';

type InfoPopoverProps = {
  header: string;
  info: string; // JSON string
};

export const InfoPopover: FC<InfoPopoverProps> = ({ header, info }) => {
  let bodyContent = info;

  // Check if JSON string then format
  try {
    const parsedJSON = JSON.parse(info);
    const formattedInfo = JSON.stringify(parsedJSON, null, 2);
    bodyContent = formattedInfo;
  } catch {}

  return (
    <Popover trigger="hover">
      <PopoverTrigger>
        <span data-testid="info-popover">
          <Icon as={BiInfoCircle} />
        </span>
      </PopoverTrigger>

      <PopoverContent>
        <PopoverArrow />
        {header && <PopoverHeader>{header}</PopoverHeader>}
        <PopoverBody maxH="300px" overflow="auto">
          <Text as="pre" fontWeight="normal" fontSize="sm">
            {bodyContent}
          </Text>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
